import i18n from '@/i18n'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/settings/feedback')({
  loader: () => {
    i18n.loadNamespaces('settings/feedback')
  },
})
